import { AuthResult } from '../auth.result';

export class CognitoAuthResponse {
  id_token: string;
  access_token: string;
  refresh_token: string;
  status: AuthResult;
}
